/**
* Classe com funções específicas para grid da tela de SamlConfiguration
* @author: Artur.bruno
* Date: 21/06/21
* Time: 10:00
*/

Greenmile.SamlConfiguration = Greenmile.SamlConfiguration || {};
Greenmile.SamlConfiguration.Grid = Greenmile.SamlConfiguration.Grid || {};

Greenmile.SamlConfiguration.Grid = function (pageLayout) {

  this.entity = "SamlConfiguration";
  this.containerGrid = "#SamlConfiguration .gridContainer";
  this.gridActionsSelector = "#SamlConfiguration .gridActions";

  this.show = function () {

    let options = {
      entity: this.entity,
      entityToActionGrid: this.entity,
      gridContainner: this.containerGrid,
      columnCheckBox: {
        show: true,
        checkBoxEventClass: [Monet.Grid.ActionsModules.BatchDelete],
        options: {
          checkOnClickRow: true
      },
      },
      columnEdit: {
        show: true
      },
      actions:[
        "EXPORT_FORMATS"
      ],
      frozenColumn: -1,
      rowHeight: 26,
      enableColumnReorder: false,
    }

    const relatedList = pageLayout.sections[1].sectionRelatedLists[0];

    options = Monet.FormBuilder.checkPermissionToEditAndDeleteBySearchGridAction(relatedList, options);

    try {
      const columns = Monet.Grid.getGridLayout(App.Forms[this.entity].layout.index, this.entity);
      const dataView = new Monet.Grid.DataProvider(columns, null, this.entity);
      const grid = new Monet.Grid.GenericGrid(this.containerGrid, dataView, columns, options);
      const appForms = App.Forms[this.entity];

      appForms.table = grid;
      appForms.dataProvider = dataView;

      const SamlConfiguration = App.Objects?.[this.entity];

      SamlConfiguration.updateGrid(Monet.Grid.addDataToGrid,true);
    } catch (e) {
      const error = new Monet.Exception.ReturnError(
        this,
        'Error on show grid on Saml Configuration screen.', e);
      error.console();
    }
  };
};

